import React from 'react';
import { Bell, Cake, Gift } from "lucide-react";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

const daysLabel = (d) => (d === 0 ? "¡Es hoy!" : d === 1 ? "Mañana" : `En ${d} días`);

export const NotificationsBell = ({ notifications = [], onGift }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="ghost" size="icon" data-testid="notifications-bell" className="relative text-gray-500 hover:text-brand-blue">
        <Bell className="w-5 h-5" />
        {notifications.length > 0 && (
          <span data-testid="notifications-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-green text-brand-dark text-[11px] font-bold flex items-center justify-center">
            {notifications.length}
          </span>
        )}
      </Button>
    </PopoverTrigger>
    <PopoverContent align="end" className="w-80 p-0 rounded-2xl overflow-hidden" data-testid="notifications-panel">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <Cake className="w-4 h-4 text-brand-blue" />
        <p className="font-bold text-sm text-brand-dark">Próximos cumpleaños</p>
      </div>
      {notifications.length === 0 ? (
        <p className="p-4 text-sm text-gray-500" data-testid="notifications-empty">Sin cumpleaños en los próximos 15 días.</p>
      ) : (
        <ul className="max-h-80 overflow-y-auto divide-y divide-gray-100">
          {notifications.map((n) => (
            <li key={n.account_id} className="p-3 flex items-center gap-3" data-testid={`notification-item-${n.account_id}`}>
              <Avatar className="w-9 h-9">
                <AvatarImage src={n.profile_picture} />
                <AvatarFallback className="bg-brand-lightBlue text-brand-blue font-bold">{n.child_name.charAt(0)}</AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-brand-dark truncate">{n.child_name} cumple {n.turning_age}</p>
                <p className="text-xs text-gray-500">{daysLabel(n.days_until)} · {n.relation === "child" ? "Tu hijo/a" : "Tu ahijado/a"}</p>
              </div>
              <Button size="sm" data-testid={`notification-gift-btn-${n.account_id}`} onClick={() => onGift(n)} className="h-8 rounded-full bg-brand-green text-brand-dark font-bold hover:bg-brand-green/90 px-3">
                <Gift className="w-3.5 h-3.5 mr-1" /> Regalar
              </Button>
            </li>
          ))}
        </ul>
      )}
    </PopoverContent>
  </Popover>
);
